/** Session titles use navigation.* keys so labels match nav.jsx. */
export const TUTORIAL_SESSIONS = [
  {
    id: 'jupas',
    route: '/jupas-calculator',
    startPath: '/jupas-calculator?tutorial=1',
    access: 'public',
    accent: 'cyan',
    titleKey: 'navigation.jupaSelect',
    descriptionKey: 'help.tutorialHub.sessions.jupas.description',
    durationKey: 'help.tutorialHub.sessions.jupas.duration',
    steps: [
      'help.tutorialHub.sessions.jupas.steps.0',
      'help.tutorialHub.sessions.jupas.steps.1',
      'help.tutorialHub.sessions.jupas.steps.2'
    ],
    visual: 'ranking'
  },
  {
    id: 'report',
    route: '/view-report',
    startPath: '/view-report?tutorial=1',
    access: 'authenticated',
    accent: 'amber',
    titleKey: 'navigation.viewReport',
    descriptionKey: 'help.tutorialHub.sessions.report.description',
    durationKey: 'help.tutorialHub.sessions.report.duration',
    steps: [
      'help.tutorialHub.sessions.report.steps.0',
      'help.tutorialHub.sessions.report.steps.1',
      'help.tutorialHub.sessions.report.steps.2'
    ],
    visual: 'report'
  },
  {
    id: 'ability',
    route: '/ability-test',
    startPath: '/ability-test?tutorial=1',
    access: 'authenticated',
    accent: 'blue',
    titleKey: 'navigation.takeTest',
    descriptionKey: 'help.tutorialHub.sessions.ability.description',
    durationKey: 'help.tutorialHub.sessions.ability.duration',
    steps: [
      'help.tutorialHub.sessions.ability.steps.0',
      'help.tutorialHub.sessions.ability.steps.1',
      'help.tutorialHub.sessions.ability.steps.2'
    ],
    visual: 'analytics'
  },
  {
    id: 'interest',
    route: '/interest-test',
    startPath: '/interest-test?tutorial=1',
    access: 'authenticated',
    accent: 'rose',
    titleKey: 'navigation.interestTest',
    descriptionKey: 'help.tutorialHub.sessions.interest.description',
    durationKey: 'help.tutorialHub.sessions.interest.duration',
    steps: [
      'help.tutorialHub.sessions.interest.steps.0',
      'help.tutorialHub.sessions.interest.steps.1',
      'help.tutorialHub.sessions.interest.steps.2'
    ],
    visual: 'interest'
  },
  {
    id: 'eddy',
    route: '/eddy',
    startPath: '/eddy?tutorial=1',
    access: 'presenter',
    accent: 'violet',
    titleKey: 'navigation.eddy',
    descriptionKey: 'help.tutorialHub.sessions.eddy.description',
    durationKey: 'help.tutorialHub.sessions.eddy.duration',
    steps: [
      'help.tutorialHub.sessions.eddy.steps.0',
      'help.tutorialHub.sessions.eddy.steps.1',
      'help.tutorialHub.sessions.eddy.steps.2'
    ],
    visual: 'chat'
  },
  {
    id: 'trajectory',
    route: '/trajectory',
    startPath: '/trajectory?tutorial=1',
    access: 'presenter',
    accent: 'emerald',
    titleKey: 'navigation.trajectory',
    descriptionKey: 'help.tutorialHub.sessions.trajectory.description',
    durationKey: 'help.tutorialHub.sessions.trajectory.duration',
    steps: [
      'help.tutorialHub.sessions.trajectory.steps.0',
      'help.tutorialHub.sessions.trajectory.steps.1',
      'help.tutorialHub.sessions.trajectory.steps.2'
    ],
    visual: 'network'
  }
];

export const tutorialAccentClasses = {
  blue: {
    bg: 'bg-accent/25',
    border: 'border-link/30',
    text: 'text-blue-800',
    badge: 'bg-blue-100 text-blue-800 border-link/30',
    shape: 'bg-primary',
    soft: 'bg-blue-100'
  },
  cyan: {
    bg: 'bg-cyan-50',
    border: 'border-cyan-200',
    text: 'text-cyan-800',
    badge: 'bg-cyan-100 text-cyan-800 border-cyan-200',
    shape: 'bg-cyan-600',
    soft: 'bg-cyan-100'
  },
  violet: {
    bg: 'bg-violet-50',
    border: 'border-violet-200',
    text: 'text-violet-800',
    badge: 'bg-violet-100 text-violet-800 border-violet-200',
    shape: 'bg-violet-600',
    soft: 'bg-violet-100'
  },
  emerald: {
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
    text: 'text-emerald-800',
    badge: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    shape: 'bg-emerald-600',
    soft: 'bg-emerald-100'
  },
  amber: {
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    text: 'text-amber-800',
    badge: 'bg-amber-100 text-amber-800 border-amber-200',
    shape: 'bg-amber-500',
    soft: 'bg-amber-100'
  },
  rose: {
    bg: 'bg-rose-50',
    border: 'border-rose-200',
    text: 'text-rose-800',
    badge: 'bg-rose-100 text-rose-800 border-rose-200',
    shape: 'bg-rose-500',
    soft: 'bg-rose-100'
  }
};

export function getTutorialSessionById(id) {
  return TUTORIAL_SESSIONS.find((s) => s.id === id) || null;
}
